import {inject, Injectable} from '@angular/core';
import {FormControl, ValidatorFn, Validators} from '@angular/forms';
import {FormUtilityService} from '../../forms/form-utility/form-utility.service';

export interface State {
  label: string;
  value: string;
}

export const NON_US_VALUE = "Non-US";

export const NON_US_OPTION = {
  "label": NON_US_VALUE,
  "value": NON_US_VALUE
};

const ZIP_VALIDATORS: ValidatorFn[] = [
  Validators.required,
  Validators.minLength(5),
  Validators.maxLength(5),
  Validators.pattern('[0-9]*')
];

@Injectable({
  providedIn: 'root'
})
export class USStatesService {
  private readonly formsUtilService: FormUtilityService = inject(FormUtilityService);

  /**
   * Array of state options
   */
  statesArray: State[] = [{"label":"AL","value":"AL"},{"label":"AK","value":"AK"},{"label":"AZ","value":"AZ"},{"label":"AR","value":"AR"},{"label":"CA","value":"CA"},{"label":"CO","value":"CO"},{"label":"CT","value":"CT"}, {"label": "DC", "value": "DC"}, {"label":"DE","value":"DE"},{"label":"FL","value":"FL"},{"label":"GA","value":"GA"},{"label":"HI","value":"HI"},{"label": "ID","value":"ID"},{"label":"IL","value":"IL"},{"label":"IN","value":"IN"},{"label":"IA","value":"IA"},{"label":"KS","value":"KS"},{"label":"KY","value":"KY"},{"label":"LA","value":"LA"},{"label":"ME","value":"ME"},{"label":"MD","value":"MD"},{"label":"MA","value":"MA"},{"label":"MI","value":"MI"},{"label":"MN","value":"MN"},{"label":"MS","value":"MS"},{"label":"MO","value":"MO"},{"label":"MT","value":"MT"},{"label":"NE","value":"NE"},{"label":"NV","value":"NV"},{"label":"NH","value":"NH"},{"label":"NJ","value":"NJ"},{"label":"NM","value":"NM"},{"label":"NY","value":"NY"},{"label":"NC","value":"NC"},{"label":"ND","value":"ND"},{"label":"OH","value":"OH"},{"label":"OK","value":"OK"},{"label":"OR","value":"OR"},{"label":"PA","value":"PA"},{"label":"RI","value":"RI"},{"label":"SC","value":"SC"},{"label":"SD","value":"SD"},{"label":"TN","value":"TN"},{"label":"TX","value":"TX"},{"label":"UT","value":"UT"},{"label":"VT","value":"VT"},{"label":"VA","value":"VA"},{"label":"WA","value":"WA"},{"label":"WV","value":"WV"},{"label":"WI","value":"WI"},{"label":"WY","value":"WY"}];

  /**
   * Returns the states array object.
   */
  getStates(includeNonUS: boolean = false): State[] {
    if (includeNonUS) {
      return [...this.statesArray, NON_US_OPTION];
    }
    return this.statesArray;
  }

  /**
   * Event handler that checks for "Non-US" & removes zip requirement.
   * @param stateCtrl
   */
  onStateChange(state: string, zipCtrl: FormControl | undefined | null, statePrestine = false): void {
    if (!!zipCtrl) {
      this.toggleZipRequirement(state, zipCtrl, statePrestine);
    }
  }

  /**
   * Method that toggles zip requirement.
   * @param zipCtrl
   */
  toggleZipRequirement(state: string, zipCtrl: FormControl, statePrestine = false): void {
    // if (!statePrestine) {
    //   zipCtrl.setValue('');
    // }
    if (state === NON_US_VALUE) {
      this.removeZipRequirement(zipCtrl);
    } else {
      this.addZipRequirement(zipCtrl);
    }
    if (!statePrestine) {
      zipCtrl.markAsTouched();
      zipCtrl.parent?.markAsTouched();
    }
  }

  /**
   * Removes the zip requirement from a form control
   * @param control
   */
  private removeZipRequirement(control: FormControl): void {
    this.formsUtilService.clearValidators(control, true);
  }

  /**
   * Adds the zip requirement to a form control
   * @param control
   */
  private addZipRequirement(control: FormControl): void {
    const params: {control: FormControl, validators: ValidatorFn | ValidatorFn[] } = {
      control: control,
      validators: ZIP_VALIDATORS
    };
    this.formsUtilService.addValidators(params);
  }
}
